export type QuestionnaireLanguage =
    // The questionnaire is available in the participant's current locale
    | { kind: 'current' }
    // It isn't, but in these languages the participant may switch to
    | { kind: 'choose'; options: string[] }
    // It shares no language with the participant: it's filled in its own language (the backend
    // serves its content whatever the participant's locale is)
    | { kind: 'original' };

// How a participant opens a questionnaire, given its languages, the participant's current locale
// and the locales their company allows (`allowedLanguages` of the session; undefined while not
// loaded). Switching to a locale outside `allowedLanguages` is rejected by the backend.
export default function resolveQuestionnaireLanguage(
    questionnaireLanguages: string[],
    locale: string,
    allowedLanguages: string[] | undefined,
): QuestionnaireLanguage {
    const languages = questionnaireLanguages.map((language) =>
        language.toLowerCase(),
    );

    if (languages.includes(locale.toLowerCase())) {
        return { kind: 'current' };
    }

    if (!allowedLanguages) {
        return { kind: 'choose', options: languages };
    }

    const allowed = allowedLanguages.map((language) => language.toLowerCase());
    const options = languages.filter((language) => allowed.includes(language));

    return options.length > 0
        ? { kind: 'choose', options }
        : { kind: 'original' };
}
